import { useId } from 'react';

const ARTWORK = '/brand/intez-helpdesk-capital.png';

/** Display the supplied artwork at its visible bounds, without modifying the PNG. */
export function BrandLogo({ theme }: { theme: 'light' | 'dark' }) {
  const id = useId().replace(/:/g, '');
  const wordmarkClip = `brand-wordmark-${id}`;
  const wordmarkLight = `brand-light-${id}`;

  return <span className="ihd-sidebar__logo" role="img" aria-label="Intez Group">
    <svg className="brand-logo__full" viewBox="25 80 1996 639" aria-hidden="true" focusable="false">
      <image href={ARTWORK} width="2054" height="766" />
      {theme === 'dark' && <>
        <defs>
          <clipPath id={wordmarkClip}><rect x="1175" y="0" width="879" height="766" /></clipPath>
          <filter id={wordmarkLight} x="0" y="0" width="100%" height="100%" colorInterpolationFilters="sRGB">
            {/* Keep the original shading/alpha; raise only the navy lettering's luminance. */}
            <feColorMatrix type="matrix" values=".06 .12 .02 0 .78  .06 .12 .02 0 .81  .06 .12 .02 0 .85  0 0 0 1 0" />
          </filter>
        </defs>
        <g className="brand-logo__contrast" clipPath={`url(#${wordmarkClip})`}>
          <image href={ARTWORK} width="2054" height="766" filter={`url(#${wordmarkLight})`} />
        </g>
      </>}
    </svg>
    <svg className="brand-logo__compact" viewBox="65 110 600 555" aria-hidden="true" focusable="false">
      <image href={ARTWORK} width="2054" height="766" />
    </svg>
  </span>;
}
